
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import config from '../../../config'
import Header from '../../Header';
import Footer from '../../Pages/Footer';
import Connectwallet from '../Login/Connect_wallet';
import Google from '../../Pages/Presale/IconBox/Google'
import Thanks from '../Login/Thanks'
// import Selectmethod from './Selectmethod';
import Selectmethod from '../Login/Selectmethod';
import Qrcode from '../Login/Qrcode';
import '../../Pages/css/scanwallet.css';
import { Container, Row, Col, Card, Button, Form, InputGroup } from 'react-bootstrap';
import * as ACTIONTYPES from '../../../redux/actionTypes'
import * as Yup from 'yup'
import { Formik } from 'formik'
import { Spin } from 'antd';
import { ERROR, Success, Warning } from '../../../utils/errors';
import { userlogin } from '../../../services/apiServices';
import { useDispatch } from 'react-redux';
import { FaRegEye } from "react-icons/fa";

const LoadingPopup = () => {
    return (
        <div className="loading-popup-container">
            <div className="loading-popup">
                <p>Please wait</p>
                <h1>Loggin in . . .</h1>
            </div>
        </div>
    );
};

const Scanwallet = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showLoading, setShowLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [passwordicon, setPasswordicon] = useState(0);

    const submitForm = async (values) => {
        setShowLoading(true)

        const payload = {
            "emailAddress": values.userName,
            "password": values.password
        }
        try {

            const { data: response } = await userlogin(payload)
            setShowLoading(false)
            if (response.status) {
                response.data.isLogin = true;
                dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
                dispatch({ type: ACTIONTYPES.USERLOGIN, payload: response.data, token: response?.data?.accessToken });
                // Success(response.message)
                navigate(`${config.baseurl}`);
            } else {
                Warning(response.message)
            }
        } catch (error) {
            setShowLoading(false)
            console.log('error', error)
            ERROR("Invalid email or password")
        }
    }


    return (
        <>
            {/* <Header /> */}

            <section className="login-section">
                <div className="login-container">
                    <Container fluid className='px-0'>
                        <Row className="justify-content-center">
                            <Col lg={12}>
                                <Row className=''>
                                    <Col lg={5} md={5} xs={12}  className=''>
                                        <div className="login-form">
                                            <div className="">
                                                <img
                                                    src="assets/images/login/coinsbackImg.svg"
                                                    alt="logo" className='coinsbackImg'
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={7} md={7} xs={12} className=''>
                                        <Spin spinning={showLoading} >
                                            {/* <div className="loginDiv" style={{ minHeight: "368px" }}> */}
                                            <div className="loginDiv pt-5">
                                                <Row>
                                                    <Col lg={7} className='mx-auto'>
                                                        <div className='form_content'>
                                                            <Form >
                                                                <div className='formDiv'>
                                                                    <div className='mb-4'>
                                                                        <img src="assets/images/scanwalletImg.png" className="scanwalletImg" />
                                                                    </div>
                                                                    <div className='text-center formheadbox'>
                                                                        <h1 className='text-primary fw-bold mb-1'>Scan to connect your wallet</h1>
                                                                        <div className='linetext mt-3 mb-3'>
                                                                            Or
                                                                        </div>
                                                                    </div>


                                                                    <Formik
                                                                        initialValues={{
                                                                            userName: "",
                                                                            password: "",
                                                                        }}
                                                                        validationSchema={Yup.object().shape({
                                                                            userName: Yup.string().nullable().required(
                                                                                'Please enter email',
                                                                            ),
                                                                            password: Yup.string().max(255).required('Please enter password')
                                                                        })}
                                                                        onSubmit={(values) => {
                                                                            submitForm(values)
                                                                        }}
                                                                    >
                                                                        {({
                                                                            errors,
                                                                            handleBlur,
                                                                            handleChange,
                                                                            handleSubmit,
                                                                            touched,
                                                                            values,
                                                                        }) => (
                                                                            <Form className="forms px-4" onSubmit={handleSubmit}>

                                                                                <div className="mb-3">
                                                                                    <Form.Label className='text-primary'>Enter the wallet address</Form.Label>
                                                                                    <InputGroup className=" theme-input">
                                                                                        <Form.Control
                                                                                            placeholder="Enter Wallet address"
                                                                                            aria-label="Username"
                                                                                            aria-describedby="basic-addon1"
                                                                                            error={Boolean(errors.userName)}
                                                                                            // helperText={errors.userName}
                                                                                            name="userName"
                                                                                            onBlur={handleBlur}
                                                                                            onChange={handleChange}
                                                                                            value={values.userName} className='py-2'
                                                                                        />
                                                                                    </InputGroup>
                                                                                    {errors.userName && touched.userName && <small className="required" style={{ color: 'red' }}>{errors.userName}</small>}
                                                                                </div>

                                                                                <Form.Group className="agree-me">
                                                                                </Form.Group>
                                                                                {/* <div className="submit-btn mt-4">
																					<Button type='submit' variant='primary' className='w-100 text-black mb-3 fw-medium'>Log In</Button>
																				</div> */}


                                                                                {/* <Form.Group className="checkBox">
																					<Form.Check type="checkbox" />
																				</Form.Group> */}
                                                                            </Form>
                                                                        )}
                                                                    </Formik>
                                                                </div>
                                                            </Form>

                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Spin>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>



                </div>


            </section>

            {/* <Footer /> */}
            {isLoading && <LoadingPopup />}

        </>
    )
}

export default Scanwallet;
